import RestModel from './RestModel';

export default {
    list: () => RestModel.list('sync/unseen'),
    markAsSeen: id => RestModel.update(`sync/${id}/seen`)
};
